import { Static, Union } from "runtypes";
import {
  DeprecatedAnthropicModelLiteral,
  ExperimentalAnthropicModelLiteral,
  StableAnthropicModelLiteral,
} from "./anthropicTypes";
import {
  DeprecatedOpenAiChatModelLiteral,
  OpenAiChatModelLiteral,
} from "./openAiTypes";
import { ChatCompletionsModelLiteral } from "./chatCompletionsTypes";
import { getNormalEnum } from "../runtypeEnums";

/** @deprecated */
export const DeprecatedModelLiteral = Union(
  ...DeprecatedAnthropicModelLiteral.alternatives,
  ...DeprecatedOpenAiChatModelLiteral.alternatives,
);
/** @deprecated */
export type DeprecatedModel = Static<typeof DeprecatedModelLiteral>;
/** @deprecated */
export const DeprecatedModel = getNormalEnum(DeprecatedModelLiteral);

export const StableModelLiteral = Union(
  ...StableAnthropicModelLiteral.alternatives,
  ...OpenAiChatModelLiteral.alternatives,
  ...ChatCompletionsModelLiteral.alternatives,
);
export type StableModel = Static<typeof StableModelLiteral>;
export const StableModel = getNormalEnum(StableModelLiteral);

export const ExperimentalModelLiteral = Union(
  ...ExperimentalAnthropicModelLiteral.alternatives,
);
export type ExperimentalModel = Static<typeof ExperimentalModelLiteral>;
export const ExperimentalModel = getNormalEnum(ExperimentalModelLiteral);

export const ModelLiteral = Union(
  ...StableModelLiteral.alternatives,
  ...ExperimentalModelLiteral.alternatives,
);
export type Model = Static<typeof ModelLiteral>;
export const Model = getNormalEnum(ModelLiteral);
